import { render, staticRenderFns } from "./CookieBanner.vue?vue&type=template&id=6af0f567&scoped=true"
import script from "./CookieBanner.vue?vue&type=script&setup=true&lang=ts"
export * from "./CookieBanner.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CookieBanner.vue?vue&type=style&index=0&id=6af0f567&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6af0f567",
  null
  
)

export default component.exports